import { fechaExacta, relativo } from './tiempo';

// Tiempo en lenguaje natural, con la fecha exacta en el tooltip. Cuando no
// hay valor muestra "Nunca" (delata al usuario que nunca entró, por ejemplo).
export default function TiempoRelativo({ valor, vacio = 'Nunca' }) {
  if (!valor) return <span className="text-gray-500">{vacio}</span>;
  return (
    <span title={fechaExacta(valor)} className="text-gray-600">
      {relativo(valor)}
    </span>
  );
}
